const cabang = () => import(/* webpackPrefetch: true */ '@/views/private/master/cabang/index.vue')
const sales = () => import(/* webpackPrefetch: true */ '@/views/private/master/sales/index.vue')
const sales_add = () => import(/* webpackPrefetch: true */ '@/views/private/master/sales/add/index.vue')
const sales_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master/sales/edit/_id.vue')
const sales_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master/sales/_id.vue')

const group_product = () => import(/* webpackPrefetch: true */ '@/views/private/master/group_product/index.vue')
const group_product_add = () => import(/* webpackPrefetch: true */ '@/views/private/master/group_product/add/index.vue')
const group_product_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master/group_product/edit/_id.vue')
const group_product_detail = () => import(/* webpackPrefetch: true */ '@/views/private/master/group_product/_id.vue')


const category_product = () => import(/* webpackPrefetch: true */ '@/views/private/master/category_product/index.vue')
const config = () => import(/* webpackPrefetch: true */ '@/views/private/master/config/index.vue')
const bank = () => import(/* webpackPrefetch: true */ '@/views/private/master/bank/index.vue')
const banner = () => import(/* webpackPrefetch: true */ '@/views/private/master/banner/index.vue')

const category_user = () => import(/* webpackPrefetch: true */ '@/views/private/master/category_user/index.vue')
const category_user_add = () => import(/* webpackPrefetch: true */ '@/views/private/master/category_user/add/index.vue')
const category_user_edit = () => import(/* webpackPrefetch: true */ '@/views/private/master/category_user/edit/_id.vue')


const routes = [
  {
    path: "/cabang",
    name: "Management Cabang",
    component: cabang,
    meta: {
      title: "Cabang"
    }
  },

  {
    path: "/sales/code",
    name: "Management Sales",
    component: sales,
    meta: {
      title: "Kode sales (Area Sales)"
    }
  },

  {
    path: "/sales/code/add",
    name: "Management Sales",
    component: sales_add,
    meta: {
      title: "Tambahkan Kode sales (Area Sales)"
    }
  },

  {
    path: "/sales/code/edit/:id",
    name: "Management Sales",
    component: sales_edit,
    meta: {
      title: "Mengubah Kode sales (Area Sales)"
    }
  },

  {
    path: "/sales/code/detail/:id",
    name: "Management Sales",
    component: sales_detail,
    meta: {
      title: "Detail Kode sales (Area Sales)"
    }
  },

  {
    path: "/product/group",
    name: "Management Produk",
    component: group_product,
    meta: {
      title: "Group Produk"
    }
  },

  {
    path: "/product/group/add",
    name: "Management Sales",
    component: group_product_add,
    meta: {
      title: "Tambahkan Group Produk"
    }
  },

  {
    path: "/product/group/edit/:id",
    name: "Management Sales",
    component: group_product_edit,
    meta: {
      title: "Mengubah Group Produk"
    }
  },

  {
    path: "/product/group/detail/:id",
    name: "Management Sales",
    component: group_product_detail,
    meta: {
      title: "Detail Group Produk"
    }
  },

  {
    path: "/product/category_product",
    name: "Management Produk",
    component: category_product,
    meta: {
      title: "Kategori Produk"
    }
  },

  {
    path: "/master/bank",
    name: "Management Master",
    component: bank,
    meta: {
      title: "Data bank"
    }
  },

  {
    path: "/promo/banner",
    name: "Management Master",
    component: banner,
    meta: {
      title: "Data banner"
    }
  },

  {
    path: "/user/category",
    name: "Management User",
    component: category_user,
    meta: {
      title: "Kategori Staff"
    }
  },

  {
    path: "/user/category/add",
    name: "Management User",
    component: category_user_add,
    meta: {
      title: "Tambahkan Kategori Staff"
    }
  },
  {
    path: "/user/category/edit/:id",
    name: "Management User",
    component: category_user_edit,
    meta: {
      title: "Mengubah Kategori Staff"
    }
  },

  {
    path: "/master/config",
    name: "Management master",
    component: config,
    meta: {
      title: "Config"
    }
  },


  
]

export default routes.map(route => {
  const meta = {
    all: false, 
    public: false,
    title: route.meta.title
  }
  return { ...route, meta }
})